function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_600_19790)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  transform: "translate(0 0.5)",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7031 0.551327C17.7896 1.00538 8.73007 7.60542 5.02734 10.8487C6.18309 14.5206 8.79192 19.2586 10.4598 24.7136C12.5363 31.505 13.5786 39.0429 14.5139 41.7407C19.7842 32.2542 33.9734 24.7947 42.1627 28.2812C50.3519 31.7677 52.5411 27.4704 53.433 26.3353L53.4629 26.2971C54.394 25.1109 57.5427 21.0994 62.5952 24.2271C65.5 26.0253 71 24.5 72.0007 23.0109C67.1358 21.9568 64.4601 17.9838 62.352 15.2271C60.2439 12.4703 56.1087 5.65947 50.5952 7.60541C45.0816 9.55135 42.0005 7.03785 40.3789 5.65947C38.7573 4.28108 35.5951 -0.0162441 25.7031 0.551327Z",
  fill: "#78CA95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6751 11.6596C29.4318 11.2542 28.3778 10.4434 27.2426 10.4434C26.1075 10.6055 25.7021 11.6596 25.9453 12.065C26.1886 12.4704 26.594 12.2272 27.4859 12.065C28.3778 11.9028 28.7021 12.4704 29.1886 12.6326C29.6751 12.7947 29.9183 12.065 29.6751 11.6596Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1315 13.5221C41.3958 13.2084 42.1788 12.4414 43.3828 12.816C44.3328 13.1116 44.6409 13.9443 44.2703 14.3841C44.0059 14.6977 43.6923 14.4334 42.9507 14.1715C42.2091 13.9095 41.853 14.3509 41.4139 14.4226C40.9748 14.4944 40.8672 13.8358 41.1315 13.5221Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.525 16.3383C31.2877 16.0331 30.8479 15.9781 30.5427 16.2155C30.2376 16.4528 30.1826 16.8926 30.4199 17.1978C31.5635 18.6681 33.6874 21.1073 37.1163 21.1975C39.986 21.2731 41.4859 19.1476 41.7879 17.9065C41.8792 17.5308 41.6488 17.1522 41.2731 17.0608C40.8975 16.9695 40.5189 17.1999 40.4275 17.5756C40.2429 18.3344 39.2132 19.8522 37.1531 19.798C34.4197 19.7261 32.6518 17.7869 31.525 16.3383Z",
  fill: "#558F69"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.39697,
  y: 4.12817,
  width: 1.62163,
  height: 63.4058,
  transform: "rotate(-17 1.39697 4.12817)",
  fill: "#474354"
}), /*#__PURE__*/React.createElement("rect", {
  y: 4.55469,
  width: 4.54057,
  height: 1.62163,
  rx: 0.810816,
  transform: "rotate(-17 0 4.55469)",
  fill: "#474354"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.89184 12.2271C3.18268 11.8217 3.73919 10.7988 5.51351 10.6865",
  stroke: "#78CA95",
  strokeWidth: 0.621622
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2252 42.957C12.6264 42.573 13.0963 41.6039 14.5943 41.4976",
  stroke: "#78CA95",
  strokeWidth: 0.621622
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5 63.6123C43.5 64.3679 47.5 64.7213 52.5 62.0771C62.3867 56.8485 67.5 74.6541 82 75.0319L80.5 84.5H-1V65.4572C0.833336 65.0794 6.2 59.522 11 56.5C17 52.7225 21 53.1465 25 54.2798C29 55.413 39.5 62.8568 41.5 63.6123Z",
  fill: "url(#paint0_linear_600_19790)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_600_19790",
  x1: 49,
  y1: 31.2126,
  x2: 47.2533,
  y2: 75.6279,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFDFE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFA"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_600_19790"
}, /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.523fc677.svg";
export { ForwardRef as ReactComponent };